import {
  emailValidator,
  phoneNumberValidator,
} from '../components/Forms/validators'

export const EmailInjestionForm = {
  model: 'EmailInjestion',
  format: [
    {
      widths: 'equal',
      fields: {
        email_address: {
          type: 'text',
          label: 'Injestion Email',
          sideLabel: '@mail.tradingsystems.io',
          sideLabelPosition: 'right',
        },
        mapping_model: {
          type: 'dropdown',
        },
      },
    },
  ],
}
